import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";

export const gain: CSSProperties = {
  fontSize: 14,
  lineHeight: 1.4,
  color: colors.blueDusk.darker,
  display: "flex",
  alignItems: "baseline",
};

export const gainStat: CSSProperties = {
  color: colors.green.darker,
  fontWeight: 600,
  marginRight: 5,
  minWidth: 32,
  textAlign: "right",
};

export const teammates: CSSProperties = {
  marginTop: 10,
};

export const numBenefittedExplanation: CSSProperties = {
  fontSize: 12,
  lineHeight: 1.67,
  color: greys.slate,
  paddingTop: 15,
};

export const infoIcon: CSSProperties = {
  fontSize: 16,
  height: 16,
  width: 16,
  color: "#dadada",
  position: "relative",
  top: 3,
  marginRight: 3,
};

export const link: CSSProperties = {
  color: colors.blueCool.standard,
  cursor: "pointer",
  textDecoration: "none",
};
